import React from 'react';

import {
    Container,
    Row,
    Col,
    H5,
} from '@bootstrap-styled/v4';

import Style from './style';
import SelectProductForm from './form/container';
import submitSelectProduct from './submit-select-product';

const SelectProduct = () => (

    <Style>
        <Container>
            <Row>
                <Col>
                    <H5 className="mb-4 text-center text-uppercase">1. Please select a product or products:</H5>
                    <SelectProductForm onSubmit={submitSelectProduct} />
                </Col>
            </Row>
        </Container>
    </Style>
);

SelectProduct.propTypes = {
};

SelectProduct.defaultProps = {
};

export default SelectProduct;
